import * as THREE from 'three';
import { World } from "../../world/World";

export class BloodEffect {
    particles: any;
    world: World;
    velocities: THREE.Vector3[] = [];
    gravity: THREE.Vector3 = new THREE.Vector3(0, -9.81, 0); // Gravity vector

    constructor(world: any) {
        this.world = world;

        // Particle geometry and material
        const particleCount = 400; // Example of 100 particles
        const geometry = new THREE.BufferGeometry();
        const positions = new Float32Array(particleCount * 3); // For 100 particles (3 values per particle for XYZ)

        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

        const material = new THREE.PointsMaterial({
            color: 0xa10e0e,   // Red color for blood
            size: 0.02,         // Size of each particle
            opacity: 0.3,      // Initial opacity
            transparent: true, // Allow fading
        });

        // Create particle system
        this.particles = new THREE.Points(geometry, material);

        // Initialize random velocities for particles
        for (let i = 0; i < particleCount; i++) {
            const randomVelocity = new THREE.Vector3(
                (Math.random() - 0.5) * 2,  // Random x velocity
                Math.random() * 3,           // Random upward velocity on y
                (Math.random() - 0.5) * 2    // Random z velocity
            );
            this.velocities.push(randomVelocity);
        }

    }


    spawn(intersectedObject: THREE.Object3D, intersectedPoint: THREE.Vector3) {
        // Set particle positions to the intersection point
        const positions = this.particles.geometry.attributes.position.array;
        for (let i = 0; i < positions.length; i += 3) {
            positions[i] = intersectedPoint.x;
            positions[i + 1] = intersectedPoint.y;
            positions[i + 2] = intersectedPoint.z;
        }

        // Mark the geometry for update
        this.particles.geometry.attributes.position.needsUpdate = true;

        // Add the particles to the scene
        this.world.graphicsWorld.attach(this.particles);

        // Start the animation to move particles and fade out
        this.animateParticles();
    }

     animateParticles() {
        const duration = 0.3; // Total duration of the blood effect in seconds
        const startTime = performance.now();
        const opacityDecayRate = 0.02; // How fast the particles fade out

        const updateParticles = () => {
            const currentTime = performance.now();
            const elapsedTime = (currentTime - startTime) / 300; // Time in seconds

            if (elapsedTime > duration) {
                // Remove particles from the scene once the effect is done
                this.world.graphicsWorld.remove(this.particles);
                return;
            }

            // Get the particle positions
            const positions = this.particles.geometry.attributes.position.array;

            // Update each particle position
            for (let i = 0; i < positions.length; i += 3) {
                const velocity = this.velocities[i / 3];

                // Apply gravity to the particle's velocity
                velocity.add(this.gravity.clone().multiplyScalar(0.01)); // Simulate gravity over time

                // Update particle positions based on velocity
                positions[i] += velocity.x * 0.01;     // X position update
                positions[i + 1] += velocity.y * 0.01; // Y position update (gravity)
                positions[i + 2] += velocity.z * 0.01; // Z position update
            }

            // Fade out the particles by reducing opacity over time
            this.particles.material.opacity = Math.max(0, this.particles.material.opacity - opacityDecayRate * elapsedTime);

            // Mark positions and material for update
            this.particles.geometry.attributes.position.needsUpdate = true;
            this.particles.material.needsUpdate = true;

            // Continue the animation loop
            requestAnimationFrame(updateParticles);
        };

        updateParticles();
    }
}
